export default {
  PENDING: 'pending',
  NEED_CONFIRMATION: 'need_confirmation',
  CONFIRMED: 'confirmed',
  DENIED: 'denied',
  DID_ATTEND: 'did_attend',
  DID_NOT_ATTEND: 'did_not_attend',
};
